export const VALUE_TO_FILTER_TYPE_CONFIG: any = {
  'tata': 'brand',
  'maruti-suzuki': 'brand',
  'hyundai': 'brand',
  'honda': 'brand',
  'mahindra': 'brand',
  'toyota': 'brand',
  'kia': 'brand',
  'mg': 'brand',
  'skoda': 'brand',
  'volkswagen': 'brand',
  'nissan': 'brand',
  'renault': 'brand',
  'ford': 'brand',
  'bmw': 'brand',
  'mercedes': 'brand',
  'audi': 'brand',
  'jeep': 'brand',
  'bajaj': 'brand',
  'aston-martin': 'brand',
  'bentley': 'brand',
  'citroen': 'brand',
  'ferrari': 'brand',
  'force-motors': 'brand',
  'isuzu': 'brand',
  'jaguar': 'brand',
  'land-rover': 'brand',
  'lexus': 'brand',
  'lotus': 'brand',
  'maserati': 'brand',
  'mclaren': 'brand',
  'mercedes-benz': 'brand',
  'porsche': 'brand',
  'rolls-royce': 'brand',
  'volvo': 'brand',
  
  'hatchback': 'bodyType',
  'suv': 'bodyType',
  'sedan': 'bodyType',
  'mpv': 'bodyType',
  'muv': 'bodyType',
  'coupe': 'bodyType',
  'convertible': 'bodyType',
  'pickup': 'bodyType',
  'crossover': 'bodyType',
  'luxury-sedan': 'bodyType',
  'luxury-suv': 'bodyType',
  'luxury-mpv': 'bodyType',
  'sports-car': 'bodyType',
  'hyper-car': 'bodyType',
  
  'petrol': 'fuelType',
  'diesel': 'fuelType',
  'cng': 'fuelType',
  'electric': 'fuelType',
  'hybrid': 'fuelType',
  
  'manual': 'transmission',
  'automatic': 'transmission',
  'amt': 'transmission',
  'cvt': 'transmission',
  
  '2seater': 'seatingCapacity',
  '4seater': 'seatingCapacity',
  '5seater': 'seatingCapacity',
  '6seater': 'seatingCapacity',
  '7seater': 'seatingCapacity',
  '8seater': 'seatingCapacity',
  '2': 'seatingCapacity',
  '4': 'seatingCapacity',
  '5': 'seatingCapacity',
  '6': 'seatingCapacity',
  '7': 'seatingCapacity',
  '8': 'seatingCapacity',
  '5-seater': 'seatingCapacity',
  '6-seater': 'seatingCapacity',
  '7-seater': 'seatingCapacity',
  '8-seater': 'seatingCapacity',
  '8-plus-seater': 'seatingCapacity',
  
  'under5lakhs': 'budget',
  'under10lakhs': 'budget',
  'under15lakhs': 'budget',
  'under20lakhs': 'budget',
  'under25lakhs': 'budget',
  'under35lakhs': 'budget',
  'under50lakhs': 'budget',
  'above50lakhs': 'budget',
  'under-5-lakh': 'budget',
  'under-10-lakh': 'budget',
  'under-15-lakh': 'budget',
  'under-20-lakh': 'budget',
  'under-25-lakh': 'budget',
  'under-35-lakh': 'budget',
  'under-50-lakh': 'budget',
  'under-1-crore': 'budget',
  'above-1-crore': 'budget',
}; 